import loadable from '@loadable/component';

export interface RouterConfigProps {
    [key: string]: {
        component: React.ComponentType<any>
    }
}

/*
 * 路由配置
 * */
const getRouterConfig = () => ({
    '/apps': {
        component: loadable(() => import(
            /* webpackChunkName: "basicLayout" */ "../layouts/BasicLayout"
        )),
    },
    '/login': {
        component: loadable(() => import(
            /* webpackChunkName: "login" */ "../pages/login"
        ))
    },
    '/registerUser': {
        component: loadable(() => import(
            /* webpackChunkName: "registerUser" */ "../pages/registerUser"
        ))
    },
    '/apps/home': {
        component: loadable(() => import(
            /* webpackChunkName: "home" */ "../pages/home"
        ))
    },
    '/apps/userSettings': {
        component: loadable(() => import(
            /* webpackChunkName: "userSettings" */ "../pages/userSettings"
        ))
    },
    '/apps/register': {
        component: loadable(() => import(
            /* webpackChunkName: "register" */ "../pages/register"
        ))
    },
    '/apps/registerDetail': {
        component: loadable(() => import(
            /* webpackChunkName: "registerDetail" */ "../pages/registerDetail"
        ))
    },
    '/apps/chain': {
        component: loadable(() => import(
            /* webpackChunkName: "chain" */ "../pages/chain"
        ))
    },
    '/apps/promoter': {
        component: loadable(() => import(
            /* webpackChunkName: "chain" */ "../pages/promoter"
        ))
    },
    '/apps/channelChain': {
        component: loadable(() => import(
            /* webpackChunkName: "chain" */ "../pages/channelChain"
        ))
    },
    '/apps/404': {
        component: loadable(() => import(
            /* webpackChunkName: "exception404" */ "../pages/exception/404"
        ))
    }
} as RouterConfigProps)


export default getRouterConfig;
